// import "@hotwired/turbo-rails";
// import "@rails/actioncable";
// import "./channels";

import Rails from "@rails/ujs";
import $ from "jquery";

Rails.start();

window.$ = $;
window.jQuery = $;

$(document).ready(function() {
    console.log("jQuery is working!");
});